import $ from '../$';
import './eq';
$.fn.first = function () {
    return this.eq(0);
};
